import { render, staticRenderFns } from "./ProfileSubscriptionError.vue?vue&type=template&id=201ca8ae&"
import script from "./ProfileSubscriptionError.vue?vue&type=script&lang=js&"
export * from "./ProfileSubscriptionError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports